import type { AdminApiImpersonationsResult } from '@/types/serializers';
import { useMutation } from '@tanstack/react-query';

type PostImpersonationParams = {
  organization_user_id: number;
};

/**
 * サポートアカウントとしてログインを開始するミューテーション。
 * POST /admin/api/impersonation を呼び出し、レスポンスの redirect_url を返す。
 */
export default function usePostAdminImpersonation() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement | undefined)
    ?.content;

  return useMutation({
    mutationFn: async (params: PostImpersonationParams): Promise<AdminApiImpersonationsResult> => {
      const response = await fetch('/admin/api/impersonation', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token || '',
        },
        body: JSON.stringify(params),
      });
      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        const message =
          errorData?.message ||
          (response.status === 403
            ? 'この操作を実行する権限がありません'
            : 'サポートアカウントログインに失敗しました');
        throw new Error(message);
      }
      return response.json() as Promise<AdminApiImpersonationsResult>;
    },
  });
}
